import React from "react"
import NestedRoute, {NestedRouteProps} from "./NestedRoute"
import {injectIntl} from "../../lang"

const PartialRoute: React.FC<NestedRouteProps> = (props) => <NestedRoute useGrid={false} {...props} />

export default injectIntl(PartialRoute)
